import * as bootstrapModal from "bootstrap/js/dist/modal";
function showExpModal(modalId: string) {
    const matchingModal = document.getElementById(modalId) as HTMLElement;

    if (matchingModal) {
        bootstrapModal.default.getOrCreateInstance(matchingModal).show();
    }
}
function hideExpModal(modalId: string) {
    const matchingModal = document.getElementById(modalId) as HTMLElement;

    if (matchingModal) {
        bootstrapModal.default.getOrCreateInstance(matchingModal).hide();
    }
}

(window as any).showExpModal = showExpModal;
(window as any).hideExpModal = hideExpModal;
